<template>
  <div>
        Welcome {{ userId }}
    </div>
</template>

<script>
export default {
    name: 'AdminDashboard',
    setup() {
        
    },
    data() {
        return {
        }
    }
}
</script>

<style>
@import'./../../assets/css/bootstrap.min.css';
@import'./../../assets/css/spinner.css';
@import'./../../assets/css/style.css';


</style>
